import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Stack,
  LinearProgress,
  ButtonGroup,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import BASEURL from "../../../Utils/Baseurl";
import UserDetailsContext from "../../../../context/auth";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/loading";
import LeaveConfig from "../ComponentPages/LeaveConfig";
import Allocation from "../ComponentPages/Allocation";
import Carryover from "../ComponentPages/Carryover";
import Encashment from "../ComponentPages/Encashment ";
import {
  LeaveconfigCreate,
  LeaveconfigUpdate,
  GetByIdLeaveconfig,
} from "../../GraphQl";

const Addleaveconfiguration = () => {
  const { circleLoading, setCirleLoading } = useLoading();
  const [activeStep, setActiveStep] = useState(0);
  const [id, setId] = useState(null);
  const { user, AccessData } = useContext(UserDetailsContext);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [leaveconfigdata, setleaveconfigdata] = useState({
    leavetype: "",
    leavetypeStatus: "unchecked",
    numberofdays: "",
    numberofdaysStatus: "unchecked",
    allownegative: false,
    allownegativeStatus: "unchecked",
    maximumnegativedays: "",
    maximumnegativedaysStatus: "unchecked",
    minaccumulationdays: "",
    minaccumulationdaysStatus: "unchecked",
    maxaccumulationdays: "",
    maxaccumulationdaysStatus: "unchecked",
    maximumconsecutivedays: "",
    maximumconsecutivedaysStatus: "unchecked",
    minaccumalationforintern: "",
    minaccumalationforinternStatus: "unchecked",
    maxaccumalationforintern: "",
    maxaccumalationforinternStatus: "unchecked",
    minaccumalationforproemp: "",
    minaccumalationforproempStatus: "unchecked",
    maxaccumalationforproemp: "",
    maxaccumalationforproempStatus: "unchecked",
    lopfrom: "",
    lopfromStatus: "unchecked",
    applybefore: "",
    applybeforeStatus: "unchecked",
    applyafter: "",
    applyafterStatus: "unchecked",
    leavewithoutpay: false,
    leavewithoutpayStatus: "unchecked",
    basedonpro: false,
    basedonproStatus: "unchecked",
    Attachmentdoc: false,
    AttachmentdocStatus: "unchecked",
    active: true,
    activeStatus: "unchecked",
    eligibleprobation: false,
    eligibleprobationStatus: "unchecked",
    eligibleIntern: false,
    eligibleInternStatus: "unchecked",
    accrualMethod: "",
    accrualMethodStatus: "unchecked",
    allocationday: "",
    allocationdayStatus: "unchecked",
    halfday: false,
    halfdayStatus: "unchecked",
    carryover: false,
    carryoverStatus: "unchecked",
    carryoverlimit: "",
    carryoverlimitStatus: "unchecked",
    carryoverexpiry: false,
    carryoverexpiryStatus: "unchecked",
    expirylimit: "",
    expirylimitStatus: "unchecked",
    encashment: false,
    encashmentStatus: "unchecked",
    encashmentfrom: "",
    encashmentfromStatus: "unchecked",
    maximumencashmentdays: "",
    maximumencashmentdaysStatus: "unchecked",
  });
  const navigate = useNavigate();
  const steps = [
    "Configure Leave",
    "Allocation Details",
    "Carry Over Details",
    "Encashment Details",
  ];

  const accrualmethod = [
    { value: "Monthly", label: "Monthly" },
    { value: "Quarterly", label: "Quarterly" },
    { value: "Half-yearly", label: "Half-yearly" },
    { value: "Annual", label: "Annual" },
  ];

  const allocationdays = [
    { value: "First Day", label: "First Day" },
    { value: "Last Day", label: "Last Day" },
  ];

  const leaveType = [
    { value: "Sick Leave", label: "Sick Leave" },
    { value: "Annual Leave", label: "Annual Leave" },
    { value: "Casual Leave", label: "Casual Leave" },
    { value: "Earned Leave", label: "Earned Leave" },
    { value: "Loss Of Pay", label: "Loss Of Pay" },
    // { value: "Privilege Leave", label: "Privilege Leave" },
    { value: "Maternity leave", label: "Maternity leave" },
    { value: "Paternity leave", label: "Paternity leave" },
    { value: "Adoption leave", label: "Adoption leave" },
    { value: "Surrogacy leave", label: "Surrogacy leave" },
    { value: "Restricted holiday", label: "Restricted holiday" },
    { value: "Work From Home", label: "Work From Home" },
  ];
  const lossofpaydata = [
    { value: "CTC", label: "CTC" },
    { value: "Basic Pay", label: "Basic Pay" },
    { value: "Gross Pay", label: "Gross Pay" },
    { value: "Net Pay", label: "Net Pay" },
  ];

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const onCancelAction = () => {
    navigate("/leave-configuration");
  };
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      leaveconfigdata.leavetypeStatus === "success" &&
      leaveconfigdata.numberofdaysStatus === "success" &&
      leaveconfigdata.maximumconsecutivedaysStatus === "success" &&
      leaveconfigdata.minaccumulationdaysStatus === "success" &&
      leaveconfigdata.maxaccumulationdaysStatus === "success" &&
      // leaveconfigdata.lopfromStatus === "success" &&
      leaveconfigdata.applyafterStatus === "success" &&
      leaveconfigdata.applybeforeStatus === "success" &&
      leaveconfigdata.accrualMethodStatus === "success" &&
      leaveconfigdata.allocationdayStatus === "success" 
      // leaveconfigdata.carryoverlimitStatus === "success" &&
      // leaveconfigdata.expirylimitStatus === "success" &&
      // leaveconfigdata.maximumencashmentdaysStatus === "success" &&
      // leaveconfigdata.encashmentfromStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const nameHandelar = (e) => {
    if (e.value) {
      setleaveconfigdata((prevState) => ({
        ...prevState,
        leavetype: e,
        leavetypeStatus: "success",
        leavewithoutpay: e.value === "Loss Of Pay",
      }));
    }
  };

  let date1 = new Date(leaveconfigdata.startDate);
  let date2 = new Date(leaveconfigdata.endDate);
  let Difference_In_Time = date2.getTime() - date1.getTime();
  let Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
  let Total_Days = Days + 1;

  //Handlechange Functions
  const handleleaveconfigdataChange = (event) => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;
    let wfhState = { ...leaveconfigdata };

    if (typeof fieldValue === "string" && fieldValue.trim() === "") {
      wfhState[fieldName + "Status"] = "unchecked";
    } else if (
      (typeof fieldValue === "number" && fieldValue >= 0) ||
      typeof fieldValue === "boolean" ||
      (typeof fieldValue === "string" && fieldValue.trim() !== "")
    ) {
      wfhState[fieldName + "Status"] = "success";
    } else {
      wfhState[fieldName + "Status"] = "error";
    }

    wfhState[fieldName] = fieldValue;
    setleaveconfigdata(wfhState);
  };

  const handleChange = (eventOrValue, action) => {
    console.log(eventOrValue, action, "typewwwwwwwww");

    let wfhState = { ...leaveconfigdata };

    let name, value;

    if (action?.name) {
      name = action.name;
      value = eventOrValue;
    } else if (eventOrValue?.target) {
      name = eventOrValue.target.name;
      value = eventOrValue.target.value?.trim();
    } else {
      return;
    }

    switch (name) {
      case "leavetype": {
        const descriptionRegex = /^[a-zA-Z\s]{1,25}$/;
        wfhState[name + "Status"] =
          value === ""
            ? "unchecked"
            : descriptionRegex.test(value)
            ? "success"
            : "error";
        break;
      }

      case "numberofdays":
      case "maximumnegativedays":
      case "carryoverlimit":
      case "expirylimit":
      case "allocationday":
      case "maximumencashmentdays":
      case "maximumconsecutivedays": {
        const numberRegex = new RegExp("^\\d{1,2}$");
        wfhState[name + "Status"] =
          value === ""
            ? "unchecked"
            : numberRegex.test(value)
            ? "success"
            : "error";
        break;
      }

      case "accrualMethod": {
        wfhState[name + "Status"] = value === "" ? "error" : "success";
        break;
      }

      default:
        break;
    }

    wfhState[name] = value;
    setleaveconfigdata(wfhState);
  };

  const handleleaveconfig = (event, selectEvent) => {
    let leaveconfigstate = { ...leaveconfigdata };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "leavetype") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          leaveconfigstate[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          leaveconfigstate[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "lopfrom") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");

        if (lengthRegex.test(event?.label) === true) {
          leaveconfigstate[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          leaveconfigstate[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      leaveconfigstate[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "numberofdays":
        case "maximumnegativedays":
        case "maximumconsecutivedays":
          {
            const numberRegex = new RegExp("^\\d{1,2}$");

            if (numberRegex.test(event.target.value?.trim())) {
              leaveconfigstate[event.target.name + "Status"] = "success";
            } else {
              leaveconfigstate[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "minaccumalationforproemp":
          {
            let result = parseFloat(event.target.value);

            if (event.target.value.trim() === "") {
              leaveconfigstate[event.target.name + "Status"] = "unchecked";
            } else if (
              isNaN(result) ||
              result < 0.5 ||
              result > leaveconfigdata.numberofdays
            ) {
              leaveconfigstate[event.target.name + "Status"] = "error";
            } else {
              leaveconfigstate[event.target.name + "Status"] = "success";
            }
          }
          break;
        case "maxaccumalationforproemp":
          {
            let result = parseFloat(event.target.value);

            if (event.target.value.trim() === "") {
              leaveconfigstate[event.target.name + "Status"] = "unchecked";
            } else if (
              isNaN(result) ||
              result < leaveconfigdata.minaccumalationforproemp ||
              result > leaveconfigdata.numberofdays
            ) {
              leaveconfigstate[event.target.name + "Status"] = "error";
            } else {
              leaveconfigstate[event.target.name + "Status"] = "success";
            }
          }
          break;
        case "minaccumalationforintern":
          {
            let result = parseFloat(event.target.value);

            if (event.target.value.trim() === "") {
              leaveconfigstate[event.target.name + "Status"] = "unchecked";
            } else if (
              isNaN(result) ||
              result < 0.5 ||
              result > leaveconfigdata.numberofdays
            ) {
              leaveconfigstate[event.target.name + "Status"] = "error";
            } else {
              leaveconfigstate[event.target.name + "Status"] = "success";
            }
          }
          break;

        case "maxaccumalationforintern":
          {
            let result = parseFloat(event.target.value);

            if (event.target.value.trim() === "") {
              leaveconfigstate[event.target.name + "Status"] = "unchecked";
            } else if (
              isNaN(result) ||
              result < leaveconfigdata.minaccumalationforintern ||
              result > leaveconfigdata.numberofdays
            ) {
              leaveconfigstate[event.target.name + "Status"] = "error";
            } else {
              leaveconfigstate[event.target.name + "Status"] = "success";
            }
          }
          break;

        case "minaccumulationdays":
          {
            let result = parseFloat(event.target.value);

            if (event.target.value.trim() === "") {
              leaveconfigstate[event.target.name + "Status"] = "unchecked";
            } else if (
              isNaN(result) ||
              result < 0.5 ||
              result > leaveconfigdata.numberofdays
            ) {
              leaveconfigstate[event.target.name + "Status"] = "error";
            } else {
              leaveconfigstate[event.target.name + "Status"] = "success";
            }
          }
          break;

        case "maxaccumulationdays":
          {
            let result = parseFloat(event.target.value);

            if (event.target.value.trim() === "") {
              leaveconfigstate[event.target.name + "Status"] = "unchecked";
            } else if (
              isNaN(result) ||
              result < leaveconfigdata.minaccumulationdays ||
              result > leaveconfigdata.numberofdays
            ) {
              leaveconfigstate[event.target.name + "Status"] = "error";
            } else {
              leaveconfigstate[event.target.name + "Status"] = "success";
            }
          }
          break;

        case "applybefore":
          {
            const numberRegex = new RegExp("^\\d{1,2}$");

            let result = parseInt(event.target.value, 10);

            if (event.target.value.trim() === "") {
              leaveconfigstate[event.target.name + "Status"] = "unchecked";
            } else if (
              numberRegex.test(event.target.value.trim()) &&
              result >= 0 &&
              result <= 99
            ) {
              leaveconfigstate[event.target.name + "Status"] = "success";
            } else {
              leaveconfigstate[event.target.name + "Status"] = "error";
            }
          }
          break;

        case "applyafter":
          {
            const numberRegex = new RegExp("^\\d{1,2}$");

            let result = parseInt(event.target.value, 10);

            if (event.target.value.trim() === "") {
              leaveconfigstate[event.target.name + "Status"] = "unchecked";
            } else if (
              numberRegex.test(event.target.value.trim()) &&
              result >= 0 &&
              result <= 30
            ) {
              leaveconfigstate[event.target.name + "Status"] = "success";
            } else {
              leaveconfigstate[event.target.name + "Status"] = "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        leaveconfigstate[event.target.name] = event.target.value;
      }
    }
    setleaveconfigdata(leaveconfigstate);
  };

  const handleallocation = (event, selectEvent) => {
    let allocationstate = { ...leaveconfigdata };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "accrualMethod") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          allocationstate[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          allocationstate[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "allocationday") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");

        if (lengthRegex.test(event?.label) === true) {
          allocationstate[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          allocationstate[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      allocationstate[selectEvent.name] = event;
    }
    setleaveconfigdata(allocationstate);
  };

  const handleencashment = (event, selectEvent) => {
    let encashmentstate = { ...leaveconfigdata };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "encashmentfrom") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          encashmentstate[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          encashmentstate[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      encashmentstate[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "maximumencashmentdays":
          {
            const numberRegex = new RegExp("^\\d{1,2}$");

            if (numberRegex.test(event.target.value?.trim())) {
              encashmentstate[event.target.name + "Status"] = "success";
            } else {
              encashmentstate[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        encashmentstate[event.target.name] = event.target.value;
      }
    }
    setleaveconfigdata(encashmentstate);
  };

// Confrimation Functions
  const handleAddwfh = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        leaveconfigSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeletewfh();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Submit Function
  const leaveconfigSubmit = async () => {
    setCirleLoading(true);

    const alldata = {
      name: leaveconfigdata.leavetype?.value,
      totalDays: parseInt(leaveconfigdata.numberofdays),
      maxConsecutiveDays: parseInt(leaveconfigdata.maximumconsecutivedays),
      isLeaveWithoutPay: leaveconfigdata.leavewithoutpay,
      eligibleForProbation: leaveconfigdata.eligibleprobation,
      eligibleForInterns: leaveconfigdata.eligibleIntern,
      allowNegative: leaveconfigdata.allownegative,
      maxNegativeDays: parseInt(leaveconfigdata.maximumnegativedays),
      minAccumulationDays: parseFloat(leaveconfigdata.minaccumulationdays),

      maxAccumulationDays: parseFloat(leaveconfigdata.maxaccumulationdays),
      minAccumulationProbation: parseFloat(
        leaveconfigdata.minaccumalationforproemp
      ),
      maxAccumulationProbation: parseFloat(
        leaveconfigdata.maxaccumalationforproemp
      ),
      minAccumulationInterns: parseFloat(
        leaveconfigdata.minaccumalationforintern
      ),
      maxAccumulationInterns: parseFloat(
        leaveconfigdata.maxaccumalationforintern
      ),
      lopFrom: leaveconfigdata.lopfrom?.value,
      applyBefore: parseInt(leaveconfigdata.applybefore),
      applyAfter: parseInt(leaveconfigdata.applyafter),
      proRataBasis: leaveconfigdata.basedonpro,
      attachmentMandatory: leaveconfigdata.Attachmentdoc,
      active: leaveconfigdata.active,

      accrualMethod: leaveconfigdata.accrualMethod.value,
      allocationDay: leaveconfigdata.allocationday?.value,
      halfDayAllowed: leaveconfigdata.halfday,

      carryOver: leaveconfigdata.carryover,
      carryOverLimit: parseInt(leaveconfigdata.carryoverlimit),
      carryOverExpiry: leaveconfigdata.carryoverexpiry,
      expiryLimitDays: parseInt(leaveconfigdata.expirylimit),

      encashmentAllowed: leaveconfigdata.encashment,
      maxEncashmentDays: parseInt(leaveconfigdata.maximumencashmentdays),
      encashmentFrom: leaveconfigdata.encashmentfrom?.value,
    };

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: LeaveconfigCreate,
          variables: { input: alldata },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;

      if (data.errors) {
        throw new Error(data.errors[0]?.message || "Something went wrong");
      }

      if (data.data?.AddLeaveConfigurations) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Configuration Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });

        navigate("/leave-configuration");

        setConfirmationDialog((prev) => ({
          ...prev,
          open: false,
        }));
        setCirleLoading(false);
        setSnackBar((prev) => ({
          ...prev,
          Success: true,
        }));
      }
    } catch (error) {
      console.error("Error submitting leave configuration:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message: error.message,
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog((prev) => ({
            ...prev,
            open: false,
          }));
        },
      });
    }
  };
 // Edit Function
  const leaveconfigedit = async () => {
    setCirleLoading(true);

    const alldata = {
      name: leaveconfigdata.leavetype?.value,
      totalDays: parseInt(leaveconfigdata.numberofdays),
      maxConsecutiveDays: parseInt(leaveconfigdata.maximumconsecutivedays),
      isLeaveWithoutPay: leaveconfigdata.leavewithoutpay,
      eligibleForProbation: leaveconfigdata.eligibleprobation,
      eligibleForInterns: leaveconfigdata.eligibleIntern,
      allowNegative: leaveconfigdata.allownegative,
      maxNegativeDays: parseInt(leaveconfigdata.maximumnegativedays),
      minAccumulationDays: parseFloat(leaveconfigdata.minaccumulationdays),

      maxAccumulationDays: parseFloat(leaveconfigdata.maxaccumulationdays),
      minAccumulationProbation: parseFloat(
        leaveconfigdata.minaccumalationforproemp
      ),
      maxAccumulationProbation: parseFloat(
        leaveconfigdata.maxaccumalationforproemp
      ),
      minAccumulationInterns: parseFloat(
        leaveconfigdata.minaccumalationforintern
      ),
      maxAccumulationInterns: parseFloat(
        leaveconfigdata.maxaccumalationforintern
      ),
      lopFrom: leaveconfigdata.lopfrom?.value,
      applyBefore: parseInt(leaveconfigdata.applybefore),
      applyAfter: parseInt(leaveconfigdata.applyafter),
      proRataBasis: leaveconfigdata.basedonpro,
      attachmentMandatory: leaveconfigdata.Attachmentdoc,
      active: leaveconfigdata.active,

      accrualMethod: leaveconfigdata.accrualMethod.value,
      allocationDay: leaveconfigdata.allocationday?.value,
      halfDayAllowed: leaveconfigdata.halfday,

      carryOver: leaveconfigdata.carryover,
      carryOverLimit: parseInt(leaveconfigdata.carryoverlimit),
      carryOverExpiry: leaveconfigdata.carryoverexpiry,
      expiryLimitDays: parseInt(leaveconfigdata.expirylimit),

      encashmentAllowed: leaveconfigdata.encashment,
      maxEncashmentDays: parseInt(leaveconfigdata.maximumencashmentdays),
      encashmentFrom: leaveconfigdata.encashmentfrom?.value,
    };

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query: LeaveconfigUpdate,
          variables: { id: id, input: alldata },
        }),
      });

      const result =
        response.data.data?.editLeaveConfigurations?.leaveConfigurationsDetails;

      if (result) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Configuration Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/leave-configuration");
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
// Delete Function
  const onDeletewfh = async () => {
    setCirleLoading(true);
    const query = `
        mutation DeleteLeaveConfigurations($id: ID!) {
  DeleteLeaveConfigurations(id: $id) {
    success
    message
  }
}
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      const responseData = response.data;

      if (responseData.data.DeleteLeaveConfigurations.success) {
        navigate("/leave-configuration");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Configuration Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        setCirleLoading(false);
      } else {
        console.log("Error deleting WFH:", responseData.data.deleteWFH.message);
      }
    } catch (error) {
      console.error("An error occurred while deleting the wfh:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // Get By ID Function
  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: GetByIdLeaveconfig,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const wfhrowData = response?.data?.data?.leaveConfigurationById;

      setleaveconfigdata({
        leavetype:
          wfhrowData.name == "annual_leave"
            ? { value: "Annual Leave", label: "Annual Leave" }
            : wfhrowData.name == "sick_leave"
            ? { value: "Sick Leave", label: "Sick Leave" }
            : wfhrowData.name == "casual_leave"
            ? { value: "Casual Leave", label: "Casual Leave" }
            : wfhrowData.name == "earned_leave"
            ? { value: "Earned Leave", label: "Earned Leave" }
            : wfhrowData.name == "loss_of_pay"
            ? { value: "Loss Of Pay", label: "Loss Of Pay" }
            : wfhrowData.name == "maternity_leave"
            ? { value: "Maternity leave", label: "Maternity leave" }
            : wfhrowData.name == "paternity_leave"
            ? { value: "Paternity leave", label: "Paternity leave" }
            : wfhrowData.name == "restricted_holiday"
            ? { value: "Restricted holiday", label: "Restricted holiday" }
            : wfhrowData.name == "work_from_home"
            ? { value: "Work From Home", label: "Work From Home" }
            : wfhrowData.name == "privilege_leave"
            ? { value: "Privilege Leave", label: "Privilege Leave" }
            : "",
        numberofdays: wfhrowData.totalDays,
        maximumconsecutivedays: wfhrowData.maxConsecutiveDays,
        leavewithoutpay: wfhrowData.isLeaveWithoutPay,
        eligibleprobation: wfhrowData.eligibleForProbation,
        eligibleIntern: wfhrowData.eligibleForInterns,
        allownegative: wfhrowData.allowNegative,
        maximumnegativedays: wfhrowData.maxNegativeDays,
        minaccumulationdays: wfhrowData.minAccumulationDays,
        maxaccumulationdays: wfhrowData.maxAccumulationDays,
        minaccumalationforproemp: wfhrowData.minAccumulationProbation,
        maxaccumalationforproemp: wfhrowData.maxAccumulationProbation,
        minaccumalationforintern: wfhrowData.minAccumulationInterns,
        maxaccumalationforintern: wfhrowData.maxAccumulationInterns,
        lopfrom: { value: wfhrowData.lopFrom, label: wfhrowData.lopFrom },
        applybefore: wfhrowData.applyBefore,
        applyafter: wfhrowData.applyAfter,
        basedonpro: wfhrowData.proRataBasis,
        Attachmentdoc: wfhrowData.attachmentMandatory,
        active: wfhrowData.active,

        accrualMethod: {
          value: wfhrowData.accrualMethod,
          label: wfhrowData.accrualMethod,
        },
        allocationday: {
          value: wfhrowData.allocationDay,
          label: wfhrowData.allocationDay,
        },
        halfday: wfhrowData.halfDayAllowed,

        carryover: wfhrowData.carryOver,
        carryoverlimit: wfhrowData.carryOverLimit,
        carryoverexpiry: wfhrowData.carryOverExpiry,
        expirylimit: wfhrowData.expiryLimitDays,

        encashment: wfhrowData.encashmentAllowed,
        maximumencashmentdays: wfhrowData.maxEncashmentDays,
        encashmentfrom: {
          value: wfhrowData.encashmentFrom,
          label: wfhrowData.encashmentFrom,
        },
      });

      setTogglePage({
        ...togglePage,
        view: true,
      });

      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the wfh details for you. This may
                    take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <>
          <Card>
            <CardHeader
              title={
                <>
                  {togglePage.view === true || togglePage.edit === true ? (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                          {togglePage.view
                            ? "View  Leave Configuration Details"
                            : "Edit  Leave Configuration Details"}
                        </MaterialTypography>
                      </Stack>
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.component === "EditLeaveConfiguration" &&
                            item.can_access
                        ) &&
                        pageState.state !== "submitting" && (
                          <ButtonGroup
                            variant="outlined"
                            aria-label="Loading button group"
                          >
                            <MaterialButton
                              variant="gradient"
                              color="dark"
                              onClick={toggleEdit}
                              startIcon={<EditIcon />}
                            >
                              Edit
                            </MaterialButton>

                            <MaterialButton
                              variant="gradient"
                              color="dark"
                              onClick={AddDelete}
                              startIcon={<DeleteIcon />}
                            >
                              Delete
                            </MaterialButton>
                          </ButtonGroup>
                        )}
                    </Stack>
                  ) : (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                      padding={1}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                          Add Leave Configuration
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  )}
                </>
              }
            />
            <CardContent sx={{ minHeight: "60vh" }}>
              <MaterialBox>
                <Stepper
                  activeStep={activeStep}
                  alternativeLabel
                  style={{
                    padding: "0px",
                    marginTop: "40px",
                    marginBottom: "20px",
                  }}
                >
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>

                {activeStep === 0 && (
                  <LeaveConfig
                    leaveconfigdata={leaveconfigdata}
                    handleChange={handleChange}
                    handleleaveconfig={handleleaveconfig}
                    leaveType={leaveType}
                    togglePage={togglePage}
                    nameHandelar={nameHandelar}
                    lossofpaydata={lossofpaydata}
                    handleleaveconfigdataChange={handleleaveconfigdataChange}
                  />
                )}
                {activeStep === 1 && (
                  <Allocation
                    handleChange={handleChange}
                    leaveconfigdata={leaveconfigdata}
                    accrualmethod={accrualmethod}
                    togglePage={togglePage}
                    handleleaveconfigdataChange={handleleaveconfigdataChange}
                    allocationdays={allocationdays}
                    handleallocation={handleallocation}
                  />
                )}
                {activeStep === 2 && (
                  <Carryover
                    leaveconfigdata={leaveconfigdata}
                    handleleaveconfigdataChange={handleleaveconfigdataChange}
                    togglePage={togglePage}
                    handleChange={handleChange}
                  />
                )}
                {activeStep === 3 && (
                  <Encashment
                    handleChange={handleChange}
                    togglePage={togglePage}
                    handleleaveconfigdataChange={handleleaveconfigdataChange}
                    leaveconfigdata={leaveconfigdata}
                    lossofpaydata={lossofpaydata}
                    handleencashment={handleencashment}
                  />
                )}
              </MaterialBox>
            </CardContent>

            <CardActions>
              <MaterialBox
                p={2}
                mt={3}
                width="100%"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                {activeStep === 0 ? (
                  <MaterialBox />
                ) : (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    style={{ maxWidth: "100px", minWidth: "100px" }}
                    onClick={handleBack}
                  >
                    <NavigateBeforeIcon />
                    Prev
                  </MaterialButton>
                )}

                <MaterialBox display="flex" gap={2}>
                  {togglePage.edit && activeStep === 3 && (
                    <>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        disabled={pageState.state === "submitting"}
                        onClick={handlecancel}
                      >
                        Cancel
                      </MaterialButton>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        disabled={pageState.state === "submitting"}
                        onClick={leaveconfigedit}
                      >
                        Update
                      </MaterialButton>
                    </>
                  )}

                  {togglePage.view === false && togglePage.edit === false && activeStep === 3 && (
                    <>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        disabled={pageState.state === "submitting"}
                        onClick={handlecancel}
                      >
                        Cancel
                      </MaterialButton>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        style={{ maxWidth: "100px", minWidth: "100px" }}
                        disabled={
                          !checkAllFields() || pageState.state === "submitting"
                        }
                        onClick={handleAddwfh}
                      >
                        Submit
                      </MaterialButton>
                    </>
                  )}

                  {activeStep !== 3 && (
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleNext}
                      style={{ maxWidth: "100px", minWidth: "100px" }}
                    >
                      Next
                      <NavigateNextIcon />
                    </MaterialButton>
                  )}
                </MaterialBox>
              </MaterialBox>
            </CardActions>
          </Card>
        </>
      )}
    </DashboardLayout>
  );
};
export default Addleaveconfiguration;
